import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import * as XLSX from "xlsx";
import fileSaver from "file-saver";
import { GET_VLP_LEDGER } from "../../../Types";
import storage from "../../../apis/Storage";

export const addCoins = (formValues) => async (dispatch) => {
  dispatch(showLoading());
  const formData = new FormData();
  formData.append("DistributorId", formValues.distributorId);
  formData.append("DistCenterId", formValues.DistCenterId);
  formData.append("DataFile", formValues.DataFile);
  if (formValues.assignedDistCenters) {
    formData.append("assignedDistCenters", formValues.assignedDistCenters);
  }
  const config = {
    headers: {
      Authorization: `Bearer ${storage.get("_appToken")}`,
      "content-type": "multipart/form-data",
      accept: "application/json",
    },
  };
  await axios
    .post("api/VLPLedger/UploadManualCoinsDisbursement", formData, config)
    .then(({ data }) => {
      dispatch(hideLoading());
      toast.success("Coin Disbursement successfully");
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const exportReport = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .get(`api/LenderFinancing/LoanVlpLedgerDetail`)
    .then(({ data }) => {
      if (data.response)
        dispatch({
          type: GET_VLP_LEDGER,
          payload: data.response,
        });
      const outputFilename = `Loan_VLP_Ledger${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const exportToCSV = (csvData, jobNumber, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if (!ws[address]) continue;
            ws[address].v =
              ws[address].v == "distributorName"
                ? "Distributor"
                : ws[address].v == "distCenterName"
                ? "DistCenter Name"
                : ws[address].v == "shopCode"
                ? "Shop Code"
                : ws[address].v == "shopName"
                ? "Shop Name"
                : ws[address].v == "vizId"
                ? "Viz Id"
                : ws[address].v == "loanId"
                ? "Loan Id"
                : ws[address].v == "loanAmount"
                ? "Loan Amount"
                : ws[address].v == "loanDate"
                ? "Loan Date"
                : ws[address].v == "loanDueAmount"
                ? "Loan Due Amount"
                : ws[address].v == "loanRepaymentDate"
                ? "Loan Repayment Date"
                : ws[address].v == "loanTotalPaid"
                ? "Loan Total Paid"
                : ws[address].v == "DeliveryManName"
                ? "DeliveryMan Name"
                : ws[address].v == "transactionId"
                ? "Transaction Id"
                : ws[address].v == "mfiType"
                ? "Mfi Type"
                : ws[address].v;
          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };
      exportToCSV(data.response, "", outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
